import React, { useState, Fragment } from "react";
import axios from "axios";
import { reduxForm } from "redux-form";

const UploadResumeFile = (props) => {

    const [resume, setResume] = useState();
    const fireEventsVal = 'no';

    let randNum = Math.floor(Math.random() * 10000000);

    const onChangeResume = e => {
        setResume(e.target.files[0]);
    }

    let resumeCB = document.getElementsByClassName('resumeOptinRadio');
    let optinsQuery;
    if(resumeCB.length > 0){
        let confirmations = resumeCB.checked.map(function(i,item){ return item.value}).get().filter(function(item){ return item !== "" }).join(",");
        optinsQuery = {
            optin_advertisers : confirmations,
            _ : + new Date()
        }
    } else {
        optinsQuery = {
            regOid : 3919,
            optin_advertisers : (window.optinsHandler.resumeOptinId || ""),
            _ : + new Date()
        }
    }

    const optinsQueryString = Object.keys(optinsQuery).map(key => key + '=' + optinsQuery[key]).join('&');

    const handleFileUpload = (e) => {

        e.preventDefault();
        props.showLoad();

        let headersConfig = {
            headers : {
                "X-Requested-With" : "XMLHttpRequest",
                "Cache-Control" : "no-cache"
            }
        }

        const formData = new FormData();
        formData.append('rand', randNum);
        formData.append('resumeFile', resume);
        formData.append('fireEvents', fireEventsVal);
        formData.append("attachResume","true");
        if(props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus"){
            axios.all([
                axios.post(process.env['REACT_APP_API_URL'] + '/upward/employee/uploadResume.jsp', formData, headersConfig),
            ])
            .then(function (response) {
                axios.post(process.env['REACT_APP_API_URL'] + "/upward/applicationSubmit.jsp", props.queryString3, headersConfig)
                
                if(window.optinsHandler.resumeOptinId !== undefined && window.optinsHandler.resumeOptinId !== ''){
                    axios.get(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins2.jsp?" + optinsQueryString);
                }
                props.hideLoad();
                props.onFormSubmit('customForm');
            })
            .catch(function (error) {
            props.hideLoad();
            console.log(error);
            });
        }else{
            axios.all([
                axios.post(process.env['REACT_APP_API_URL'] + '/upward/employee/uploadResume.jsp', formData, headersConfig)
            ])
            .then(function (response) {
                if(window.optinsHandler.resumeOptinId !== undefined && window.optinsHandler.resumeOptinId !== ''){
                    axios.get(process.env['REACT_APP_API_URL'] + "/upward/resumeOptins2.jsp?" + optinsQueryString);
                }
                props.hideLoad();
                props.onFormSubmit('customForm');
            })
            .catch(function (error) {
            props.hideLoad();
            console.log(error);
            });
        }

    }


    return (
        <Fragment>
            <div>
                <a href="#" onClick={() => props.onFormSubmit('uploadResume')}>back</a>
                <h3 className="center">Upload your resume</h3>
                <p>Take the work out of finding work. When you add your resume, you can apply to jobs instantly and employers can find you!</p>
                <form onSubmit={handleFileUpload}>
                    <div id="fileUpload">
                        <label htmlFor="resumeFile">File:</label>
                        <input type="file" name="resumeFile" id="resumeFile" className="inputBox inputSmall" onChange={onChangeResume} required />
                    </div>
                    <div><button type="submit" className="btn btnSmall fullwidth btn-block">Continue</button></div>
                    <div className={"loading " + ( props.loading ? 'in' : '')}><div className="spinner"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>
                </form>
            </div>
        </Fragment>
    )

}

export default reduxForm({
    form: 'UploadResumeFile',
  })(UploadResumeFile);
